<template>
  <div class="h5-page">
    <div class="h5-header">配送任务</div>
    <div class="h5-body">
      <div v-if="task && task.id" class="h5-card">
        <div class="row">
          <span class="label">任务号</span><span>{{ task.taskNo }}</span>
        </div>
        <div class="row">
          <span class="label">配送员</span><span>{{ task.courierName }}</span>
        </div>
        <div class="row">
          <span class="label">路线方案</span><span>{{ task.routeModeName }}</span>
        </div>
        <div v-if="task.routeSummary" class="row">
          <span class="label">方案摘要</span><span>{{ task.routeSummary }}</span>
        </div>
        <div class="row">
          <span class="label">签收进度</span>
          <span :class="task.status === '2' ? 'done' : ''">{{ task.signedCount }}/{{ task.stopCount }}（{{ task.statusName }}）</span>
        </div>
      </div>
      <div v-if="task && task.status === '2'" class="h5-card finish-card">
        <a-icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" />
        <span>全部配送点已签收，任务完成</span>
      </div>
      <div v-for="stop in stops" :key="stop.id" class="h5-card stop-card" :class="{ signed: stop.signed }">
        <div class="stop-head">
          <span class="stop-seq">{{ stop.seq }}</span>
          <span class="stop-customer">{{ stop.customerName || '客户' }}</span>
          <a-tag v-if="stop.signed" color="green">已签收</a-tag>
          <a-tag v-else color="orange">待送达</a-tag>
        </div>
        <div class="stop-line">出库单：{{ stop.xsckNo }}</div>
        <div class="stop-line addr">地址：{{ stop.address || '-' }}</div>
        <div v-if="stop.signedTime" class="stop-line">签收时间：{{ stop.signedTime }}</div>
        <template v-if="!stop.signed && task.status !== '2'">
          <div class="sign-area">
            <a-input v-model="stop.xsckInput" placeholder="出库单号校验（可选）" size="small" class="sign-input" />
            <a-button type="primary" size="small" :loading="stop.signing" @click="handleSign(stop)">签收送达</a-button>
          </div>
          <div class="sign-tip">可不填出库单号直接签收；填写则校验一致后签收</div>
        </template>
      </div>
      <div v-if="!loading && !task" class="empty">{{ errorMsg || '任务不存在或链接已失效' }}</div>
    </div>
  </div>
</template>
<script>
import { getH5DeliveryTask, signH5DeliveryStop } from '@/api/plugin/orderReceive'
import './h5-common.css'

export default {
  name: 'H5Delivery',
  data() {
    return {
      loading: false,
      task: null,
      errorMsg: ''
    }
  },
  computed: {
    token() {
      return this.$route.params.token
    },
    stops() {
      return (this.task && this.task.stops) || []
    }
  },
  created() {
    this.loadTask()
  },
  methods: {
    loadTask() {
      this.loading = true
      getH5DeliveryTask(this.token).then(res => {
        if (res.success && res.data) {
          this.task = res.data
          this.$set(this.task, 'stops', (this.task.stops || []).map(s =>
            Object.assign({ xsckInput: '', signing: false }, s)))
        } else {
          this.errorMsg = res.message
          this.$message.warning(res.message)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    /** 逐点签收：可选 XSCK 单号校验，签收后刷新进度 */
    handleSign(stop) {
      this.$set(stop, 'signing', true)
      signH5DeliveryStop(this.token, stop.id, { xsckNo: stop.xsckInput || undefined }).then(res => {
        if (res.success) {
          this.$message.success('签收成功')
          this.loadTask()
        } else {
          this.$message.warning(res.message)
        }
      }).finally(() => {
        this.$set(stop, 'signing', false)
      })
    }
  }
}
</script>
<style scoped>
.row {
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
  font-size: 14px;
}
.label {
  color: #888;
}
.done {
  color: #52c41a;
  font-weight: 600;
}
.finish-card {
  text-align: center;
  color: #52c41a;
  font-weight: 600;
}
.stop-head {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}
.stop-seq {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #1890ff;
  color: #fff;
  text-align: center;
  line-height: 24px;
  font-size: 13px;
  margin-right: 8px;
  flex-shrink: 0;
}
.stop-customer {
  flex: 1;
  font-weight: 600;
}
.stop-line {
  color: #666;
  font-size: 13px;
  margin: 3px 0;
}
.stop-line.addr {
  word-break: break-all;
}
.stop-card.signed {
  opacity: 0.7;
}
.sign-area {
  display: flex;
  gap: 8px;
  margin-top: 10px;
}
.sign-input {
  flex: 1;
}
.sign-tip {
  color: #999;
  font-size: 12px;
  margin-top: 6px;
}
.empty {
  text-align: center;
  color: #999;
  padding: 40px 0;
}
</style>
